/* eslint-disable no-unused-vars */
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../store/slices/Auth/authSlice";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/bg-login.jpg";
import mbhcImage from "../assets/309838218_493827409423554_2856450506263720562_n.jpg";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, error } = useSelector((state) => state.auth);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userName || !password) return;

    const result = await dispatch(
      login({ username: userName, password: password }),
    );
    if (login.fulfilled.match(result)) {
      navigate("/dashboard");
    }
  };

  const layoutStyle = {
    backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.4), rgba(15, 23, 42, 0.4)), url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
  };

  return (
    <div style={layoutStyle}>
      <style>{`
        .glass-card {
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 20px;
        }
        .login-input {
          transition: all 0.3s ease;
          border: 1px solid #cbd5e1 !important;
        }
        .login-input:focus {
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1) !important;
          background: white !important;
        }
        .btn-hover:hover {
          background-color: #2563eb !important;
          transform: translateY(-1px);
          box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.4) !important;
        }
      `}</style>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
            <div className="glass-card shadow-lg p-4 p-sm-5">
              {/* BRANDING SECTION */}
              <div className="text-center mb-4">
    <div className="text-center mb-4">
                <img
                  src={mbhcImage}
                  alt="Profile"
                  className="mx-auto shadow-lg object-fit-cover mb-3"
                  style={{
                    width: "160px",
                    height: "140px",
                    borderRadius: "16px",
                  }}
                />
              </div>
                <h2
                  className="fw-bolder m-0"
                  style={{ letterSpacing: "-1.5px", color: "#0f172a" }}
                >
                  HR<span style={{ color: "#3b82f6" }}>IS</span>
                </h2>
                <p className="text-muted small mt-2 fw-medium">
                  Sign In to your account
                </p>
              </div>

              {error && (
                <div className="alert alert-danger py-2 border-0 small mb-4 d-flex align-items-center rounded-3">
                  <i className="bi bi-exclamation-circle-fill me-2"></i>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-bold small text-secondary">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control form-control-lg login-input"
                    style={{ fontSize: "0.9rem", borderRadius: "10px" }}
                    placeholder="name@emi-solutions.ph"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    disabled={status === "loading"}
                    required
                  />
                </div>

                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-bold small text-secondary m-0">
                      Password
                    </label>
                    <button
                      type="button"
                      className="btn btn-link p-0 text-decoration-none fw-bold"
                      style={{ color: "#3b82f6", fontSize: "0.7rem" }}
                      onClick={() => navigate("/change-password")}
                    >
                      Forgot Password?
                    </button>
                  </div>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control form-control-lg login-input"
                      style={{
                        fontSize: "0.9rem",
                        borderRadius: "10px",
                        paddingRight: "45px",
                      }}
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={status === "loading"}
                      required
                    />
                    <button
                      type="button"
                      className="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent pe-3 text-muted"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                      ></i>
                    </button>
                  </div>
                </div>

                <div className="mb-4 form-check d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rem"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <label
                    className="form-check-label small text-muted fw-semibold ms-2"
                    htmlFor="rem"
                    style={{ cursor: "pointer", fontSize: "0.8rem" }}
                  >
                    Keep me logged in
                  </label>
                </div>

                <div className="d-grid">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg fw-bold shadow-sm btn-hover border-0 transition-all"
                    style={{
                      backgroundColor: "#3b82f6",
                      borderRadius: "10px",
                      fontSize: "0.95rem",
                      height: "48px",
                    }}
                    disabled={status === "loading"}
                  >
                    {status === "loading" ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Authenticating...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>
                </div>
              </form>
            </div>

            <div className="text-center mt-4">
              <p className="text-white small opacity-75">
                &copy; 2026 EMI Solutions Philippines Inc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
